module.exports = __webpack_public_path__ + "img/hkqaa-hkregistration-cert.c34da022.jpg";